import { render, staticRenderFns } from "./KeymapPanel.vue?vue&type=template&id=bdd21ef6&"
import script from "./KeymapPanel.vue?vue&type=script&lang=js&"
export * from "./KeymapPanel.vue?vue&type=script&lang=js&"
import style0 from "./KeymapPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports